module.exports = __webpack_public_path__ + "img/gykt.469bb57d.png";